<template>
    <div class="ks-header">
      <div class="ks-header__box">
        <van-icon class="ks-header__i" name="arrow-left" @click="rut"/>{{title}}
      </div>
    </div>
</template>
<script>
export default {
  name:'Header',
  props:{
    title:String
  },
  methods:{
    rut(){
      this.$router.back(-1);
    }
  }
}
</script>
<style scoped>
 .ks-header{
      width: 100%;
      height: 48px;
      background-color: #fff;
      position: relative;
    }
    .ks-header__box{
      font-size: 17px;
      font-weight: bold;
      text-align:center;
      line-height: 48px;
    }
    .ks-header__i{
      position: absolute;
      top: 50%;
      line-height: 30px;
      margin-top: -15px;
      left: 15px;
    }
</style>




// WEBPACK FOOTER //
// src/ks-components/Header.vue